document.addEventListener('DOMContentLoaded', function() {


    let table_size_tab = document.querySelectorAll('.size-tab-link');
    if(table_size_tab){
        table_size_tab.forEach(btn => btn.addEventListener('click', (event) => {
            event.preventDefault();
            let container = findAncestor (event.currentTarget, 'size-chart-table');
            container.querySelectorAll('.size-tab-link').forEach(el=>el.classList.remove("active"));
            container.querySelectorAll('.size-table-wrapper .size-table').forEach(el=>el.classList.remove("active"));
            event.currentTarget.classList.add("active");
            let data_type = event.currentTarget.getAttribute('data-type');
            container.querySelector('.size-table-wrapper .size-table[data-type="'+ data_type +'"]').classList.add("active");
        }));
    }

    // .table-navigation
    const tableBtnContainer = document.querySelector('.table-navigation ul')
    const tableList = document.querySelectorAll('.table-custom-wrapper')
    const btnBackList = document.querySelectorAll('.btn-come-back')

    tableBtnContainer.addEventListener('click', tableController)
    btnBackList.forEach(i =>{
        i.addEventListener('click', function (){
            tableBtnContainer.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        })
    })
    seachActiveTable ()

    function tableController (e){
        let target = e.target
        if ( target.hasAttribute('data-handle-table') && !target.classList.contains('active')){
            tableBtnContainer.querySelector('li.active').classList.remove('active')
            target.classList.add('active')
            if (window.innerWidth < 960){
                document.querySelector('.table-custom-wrapper.active').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
        seachActiveTable ()
    }
    function seachActiveTable (){
        tableList.forEach(i =>{
            let activeBtnData = document.querySelector(".table-navigation ul li.active").dataset.handleTable
            if (i.classList.contains('active') && activeBtnData !== i.dataset.handleTable){
                i.classList.remove('active')
            } else if (activeBtnData === i.dataset.handleTable){
                i.classList.add('active')
            }
        })
    }

    function findAncestor (el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    //Inc - cm conversion
    let unit_conversion_buttons = document.querySelectorAll('.unit-conversion input[type="radio"]');
    if(unit_conversion_buttons){
        unit_conversion_buttons.forEach(unit_btn => unit_btn.addEventListener('change', (event) => {
            event.preventDefault();
            event.stopPropagation();
            let container = document.querySelector('.table-custom-wrapper.active');
            let tables = container.querySelectorAll('.main-table-block .size-table-wrapper .size-table');
            tables.forEach(table => {
                if(unit_btn.value == 'cm'){
                    table.querySelectorAll('.size-table-cell').forEach(cell => {
                        let cell_val = cell.innerHTML;
                        if(cell_val && !isNaN(cell_val) && cell.classList.contains('in')){
                            let converted_val = Math.round(cell_val * 2.54);
                            cell.classList.add('cm');
                            cell.classList.remove('in');
                            cell.innerHTML = converted_val;
                        }
                    });
                }else{
                    table.querySelectorAll('.size-table-cell').forEach(cell => {
                        let cell_val = cell.innerHTML;
                        if(cell_val && !isNaN(cell_val) && cell.classList.contains('cm')){
                            let converted_val = cell.getAttribute('data-default');
                            cell.classList.add('in');
                            cell.classList.remove('cm');
                            cell.innerHTML = converted_val;
                        }
                    });
                }
            });
        }));
    }
});


